import { CommonModule, formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FeatureService } from '../../../../core/services/feature.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { AppWindows2 } from '../../../../core/utils/app-windows';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-feature',
    templateUrl: './feature.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule,
        NgxPaginationModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
    ],
    styleUrls: ['./feature.component.css']
})
export class FeatureComponent {
  buttonsPermission :any|undefined;
  search_text=""
   structures:any[] =[]
   selectedWindows:any[] =[]
   windows:any[] =AppWindows2
   data:any[] =[]
   classrooms:any[] =[]
   selected_data:any;
   modalOption:any; 
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="admin-features"
 
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
 
 
   constructor(
     private featureService:FeatureService,
     private toastrService:ToastrService,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
     this.init()
    this.getActions()
   }
 
   init(){
     this.getAll()
   
   }
 
  
 
   getAll(){
     this.featureService.getAll().subscribe((res:any)=>{
       this.data=res.data
       this.pg.pageSize=10
       this.pg.p=0
       this.pg.total=res.data.length
       this.modalService.dismissAll()
     },
     (err:any)=>{
 AppErrorShow.showError("Gestion des fonctionnalités et interfaces",err)
     })
   }
 
 
   store(value:any){
     this.loading=true
 
     let date1= formatDate(new Date(value.start_date),"dd-MM-yyyy","fr_FR")
     let date2= formatDate(new Date(value.end_date),"dd-MM-yyyy","fr_FR")
     
     if (date1>date2) {
       this.toastrService.error("La date de début ne peut être postérieure à la date de fin")
       return ;
     }
     
     this.featureService.store(value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des fonctionnalités et interfaces",err)
 
     })
   }
   update(value:any){
     this.loading=true
     this.featureService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des fonctionnalités et interfaces",err)
 
     })
   }
   delete(){
     if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.featureService.delete(this.selected_data.id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion des fonctionnalités et interfaces",err)
 
     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.is_active
     this.selectedWindows=el.windows
     console.log(el.windows)
   }
   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalOption={centered:false,size:"lg"}
     this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }
 

   loadData2(ev:any){

   }
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.featureService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des fonctionnalités et interfaces",err)
 
       })
   }
   getPage(event:any){
     this.pg.p=event
   }
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:false,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }
}
